import React, { useEffect, useRef, useState } from "react";
import "./PopUp.css";
import { Globals as OldGlobals } from "../../global/Globals";
import CheckboxDropDown from "../CheckboxDropDown/CheckboxDropDown";
import CryptoUtils from "../../util/cryptoUtils";
import { useLanguage } from '../../context/Languagecontext';
import FallBackLabel from '../../global/Globals_Eng.json';

const PopUp = (props) => {
  const {
    customClassName,
    email,
    limit,
    mail_rejection,
    dropdownData,
    textAreaTitle,
    textAreaStyle,
    proposalBodyVal,
    emailContent,
    comments,
    disable = false,
    newRejection,
    isNewAcceptanceMail,
    isCloseRequired=true
  } = props;
  const { Globals ,languages, setLanguages } = useLanguage();
  const parser = new DOMParser();
  const [isOpen, setIsOpen] = useState(true);
  const [text, setText] = useState("");
  const [isEmailContentInvaid, setIsEmailContentInvaid] = useState(false);
  const [isReasonUnselected, setIsReasonUnselected] = useState(false);
  const [dropdownState, setDropdownState] = useState({
      activeDropdown: false,
      dropdowns: {selected: [], selectedText: []},
    });
  const customStyle = "abort-popup-content";
   const dropdownRefs = useRef({}); 
   const [rejectionOptionSelected, setRejectionOptionSelected]=useState({reason1:false, reason2:false});
   const [rejectionReasons, setRejectionReasons]=useState({reason1:'', reason2:''});
   const [approverOptionSelected, setApproverOptionSelected]=useState({isSM:false, isChannelHead:false, isHeadOfProduction:false});
   const multiLang = localStorage.getItem("lang");
  const closePopup = (actionButtonText) => {

    if (actionButtonText == Globals.HALF_PAGE_BRIEF_DETAILS.ACTION_BUTTON_TEXT) {
      props?.onClose && props.onClose(actionButtonText);
      setIsOpen(false);
    }
    else {
      props?.onClose && props.onClose();
      setIsOpen(false);
    }
    if(localStorage.getItem("reasonId")){
      localStorage.removeItem("reasonId");
    }
  };

  const handleNegativeAction = () => {
    props.negativeActionText === Globals.DISCARD ? props.negativeAction(true, false, true) : props.negativeAction(text);
    props.clearData && props.clearData();
    CryptoUtils.saveToLocalStorage("clear", false);
    if (props.isEmailContentRequired) {
      console.log("TExt",text);
      return text;
    }

  };

  const handleClickOutside = (event) => {
    // Check if the click is outside all dropdowns
    const isClickInsideDropdown = Object.values(dropdownRefs.current).some((ref) =>
      ref?.contains(event.target)
    );
    if (!isClickInsideDropdown) {
      handletog(dropdownState.activeDropdown)
    }
  };

  const isEmailPopupVaild = (mail_rejection && !(dropdownState.dropdowns.selected.length && text.length)) || (!text.length && email);
  
  useEffect(() => {
    if(dropdownState.activeDropdown){
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    }
    }, [dropdownState]);

  const handleNormalAction = () => {
    const requestBody = {
      ...proposalBodyVal,
      comment: text,
      ...(mail_rejection && {
        rejectionReason: dropdownState?.dropdowns?.selectedText?.join(),
      }),
    };

    props.normalAction(requestBody);
    closePopup();
    props.clearData && props.clearData();
    CryptoUtils.saveToLocalStorage("clear", false);
  };

const handleEmailChange = (e) =>{
  const inputText = e.target.value;
  inputText.length === 0 ? setIsEmailContentInvaid(true) : setIsEmailContentInvaid(false);
  setText(inputText)
}

  const handleChange = (e) => {
    const inputText = e.target.value;
    setText(inputText);
  };
  const handletog = (value) =>{
    (value && !dropdownState.dropdowns.selected.length>0) ? setIsReasonUnselected(true) :setIsReasonUnselected(false)
    setDropdownState((prev) => ({ ...prev, activeDropdown : !value }));
}

const handleSelectAll = (selectAll, options) => {
  const selectedDataSting = options.map((option) => String(option.reasonId));
  const selectedDataText = options.map((option) => String(option.reasonName));
  setDropdownState((prev) => ({
    ...prev,
    dropdowns: {
      selected: selectAll ? selectedDataSting : [],
      selectedText: selectAll ? selectedDataText : [],
    },
  }));
};

const handleSelect = (value) => {
  setDropdownState((prev) => {
    const dropdown = prev.dropdowns;
    if (!dropdown) return prev;
    const isSelected = dropdown.selected.includes(String(value.reasonId));
    const inSelectedText = dropdown.selectedText.includes(String(value.reasonName));
    const newSelected = isSelected
      ? dropdown.selected.filter((item) => item !== String(value.reasonId)).map(String)
      : [...dropdown.selected.filter((item) => item !== String(value.reasonId)), String(value.reasonId)];

    const newSelectedText = inSelectedText
      ? dropdown.selectedText.filter((item) => item !== String(value.reasonName)).map(String)
      : [
          ...dropdown.selectedText.filter((item) => item !== String(value.reasonName)),
          String(value.reasonName),
        ];
    return {
      ...prev,
      dropdowns: {
          selected: newSelected,
          selectedText: newSelectedText,
      },
    };
  });
}

  useEffect(() => {
    if (!isOpen) {
      // This code will run after isOpen becomes false
      props?.onClose && props.onClose();
    }
  }, [isOpen, props]);

  /**
   * New Rejection mail Implementation Start
   */

  const handleRejectionSelectionOption = (option) => {
    if (option == 1) {
      setRejectionOptionSelected({ reason1: true, reason2: false });
    }
    else if(option===2){
      setRejectionOptionSelected({ reason1: false, reason2: true });
    }
    CryptoUtils.saveToLocalStorage("reasonId",option);
  }
  //New Rejection mail Implementation End
  return (
    <>
      {isOpen && (
        <div className="popup">
        <div className="popup-bg-cover">
            <div className={`popup-content ${customClassName || customStyle}`}>
            <div className={`popup-title ${props.popupType === "confidential-agreement"?'confidential-agreement-title':''}`}>
                <h4>{props.title || ""}</h4>
              {isCloseRequired&&<img
                  className={`close-button-popup`}
                src={Globals.IMG.CLOSE}
                onClick={closePopup}
              />}
            </div>
            <div
              className={props.title === Globals.HALF_PAGE_BRIEF_DETAILS.SHELVE_BRIEF1 ? "shelve-popup-text" : "popup-text"}
              style={{
                display: props.popupType === "successedit" ? "none" : "block",
              }}
            >
              <div style={{ whiteSpace: 'pre-line' }}>
                {props.popupType === "confidential-agreement" && (
                  <>
                    <span>{Globals.SIGNUP.CONFIDENTIAL_INFO}</span>
                  </>
                )}
                {props.popupType === "success" && (
                  <>
                    <span>{Globals.SIGNUP.POPUP.SUCCESS.L1_MESSAGE}</span>
                    <br />
                    <span>{Globals.SIGNUP.POPUP.SUCCESS.L2_MESSAGE}</span>
                  </>
                )}
                {props.popupType === "approveProposal" && (
                  <>
                    <span>{Globals.SYS_ADMIN.POPUP.APPROVE_PROMPT_L1}</span>
                    <br />
                    <span>{Globals.SYS_ADMIN.POPUP.APPROVE_PROMPT_L2}</span>
                  </>
                )}
                {props.popupType === "approveProposal-Producer" && (
                  <>
                    <span>{Globals.SYS_ADMIN.POPUP.APPROVE_PRODUCER_PROMPT_L1}</span>
                    <br />
                    <span>{Globals.SYS_ADMIN.POPUP.APPROVE_PRODUCER_PROMPT_L2}</span>
                  </>
                )}
                {props.popupType === "rejectProposal" && (
                  <>
                    <span>{Globals.SYS_ADMIN.POPUP.REJECT_PROMPT_L1}</span>
                    <br />
                    <span>{Globals.SYS_ADMIN.POPUP.REJECT_PROMPT_L2}</span>
                  </>
                )}
                {props.popupType === "rejectProposal-Producer" && (
                  <>
                    <span>{Globals.SYS_ADMIN.POPUP.REJECT_PROMPT_PRODUCER_L1}</span>
                    <br />
                    <span>{Globals.SYS_ADMIN.POPUP.REJECT_PROMPT_PRODUCER_L2}</span>
                  </>
                )}
                {props.popupType !== "success" &&
                  props.popupType !== "successedit" &&
                  (props.text || "")}
              </div>
              <br />
              {mail_rejection && (
                <div id="popup-email-rejection">
                    <label className="popup-email-title">
                    {Globals.REJECTION_MAIL_VIRTUAL_PITCH.SUB_TITLE}
                      <span id="mandatory" className="mandatory">
                        {Globals.MANDATORY_FIELD}
                      </span>
                    </label>
                    <div style={{marginBottom: '10px'}}>
                    <CheckboxDropDown
                      isOpen={dropdownState.activeDropdown}
                      options={dropdownData}
                      onToggle={() => handletog(dropdownState.activeDropdown)}
                      onSelectAll={(selectAll, options) =>
                        handleSelectAll(selectAll, options)
                      }
                      onSelect={handleSelect}
                      selectedValues={dropdownState.dropdowns.selected}
                      title={Globals.REJECTION_MAIL_VIRTUAL_PITCH.PLACEHOLDER}
                      selectedItems={dropdownState.dropdowns.selectedText}
                      className={"dropdown-rejection"}
                      outerDivClassName={"rejectionDropdownSize"}
                      longInputText = {true}
                      dropdownRef={(el) => (dropdownRefs.current["VirtualPitch"] = el)}
                    />
                    {isReasonUnselected && <div><img id="email-popup-error" className="email-popup-error" src={OldGlobals.IMG.ERROR} alt="name error" /><label className='invalid-email-popup'>{Globals.ERROR_MESSAGES.EMPTY_REASON_DD}</label></div>}
                    </div>
                </div>
              )}
              {(email || mail_rejection) && (
                <div id="popup-email">
                <div className="popup-email-title">{textAreaTitle}
                  <span id="mandatory" className="mandatory">
                        {Globals.MANDATORY_FIELD}
                  </span>
                </div>
                <div className="popup-email-container">
                  <label className="popup-email-label"> 
                    {Globals.POPUP_EMAIL_HEADER + emailContent}
                  </ label>
                  <div style={{margin:'10px 0px'}}>
                        <textarea
                          value={text}
                          onChange={handleEmailChange}
                          onBlur={handleEmailChange}
                          placeholder={Globals.POPUP_EMAIL_PLACEHOLDER}
                          className={textAreaStyle}
                        /> 
                  {isEmailContentInvaid && <div><img id="email-popup-error" className="email-popup-error" src={OldGlobals.IMG.ERROR} alt="name error" /><label className='invalid-email-popup'>{Globals.ERROR_MESSAGES.EMPTY_EMAIL_CONTENT}</label></div>}
                  </ div>
                  <label className="popup-email-label"> 
                    {(props.popupType==='rejectProposal'||props.popupType==='rejectProposal-Producer')?Globals.SYS_ADMIN.POPUP.REJECT_EMAIL_TEMPLATE_FOOTER:Globals.POPUP_EMAIL_FOOTER}
                  </ label>
                </div>
              </div>
              )}
              {/** Start of new Rejection email implementation */}
              {/**This code is for showing up rejection when a proposal is rejected with only reasons */}
                {(newRejection &&
                  <div id="popup-email newRejection-email-container">
                    <div className="popup-email-title">{Globals.NEW_REJECTION_EMAIL_PROPS.REASON_SELECTION_SECTION_LABEL}
                      <span id="mandatory" className="mandatory">
                        {Globals.MANDATORY_FIELD}
                      </span>
                    </div>
                    <div>
                      <div className="newRejectionMail-options-container">
                        <span className="newRejectionMail-Reason-1">
                          <input type="radio"
                            className="newRejection-reasons-radios"
                            name={Globals.INTERNAL_USERS_ROLE_LIST}
                            checked={rejectionOptionSelected.reason1}
                            value="1"
                            onClick={() => handleRejectionSelectionOption(1)}
                          />
                          {Globals.NEW_REJECTION_EMAIL_PROPS.REASON_1_LABEL}
                        </span>
                        <span className="newRejectionMail-Reason-2">
                          <input type="radio"
                            className="newRejection-reasons-radios"
                            name={Globals.INTERNAL_USERS_ROLE_LIST}
                            checked={rejectionOptionSelected.reason2}
                            value="1"
                            onClick={() => handleRejectionSelectionOption(2)}
                          />
                          {Globals.NEW_REJECTION_EMAIL_PROPS.REASON_2_LABEL}
                        </span>
                      </div>
                    </div>
                    <br></br>
                    {(rejectionOptionSelected.reason2 || rejectionOptionSelected.reason1)&&<><div className="newRejection-email-content-label1">
                      <label className="newRejection-email-content-label">{Globals.NEW_REJECTION_EMAIL_PROPS.EMAIL_CONTENT_LABEL}</label>
                    </div>
                    <div className="newRejection-email-content-container">
                      <label className="newRejection-email-content">{rejectionOptionSelected.reason1 ? Globals.NEW_REJECTION_EMAIL_PROPS.REASON_1_MAIL_CONTENT :
                        Globals.NEW_REJECTION_EMAIL_PROPS.REASON_2_MAIL_CONTENT}
                      </label>
                    </div>
                    <div className="newRejection-mail-word-counter">{
                      (rejectionOptionSelected.reason1 ? Globals.NEW_REJECTION_EMAIL_PROPS.REASON_1_MAIL_CONTENT.length :
                        Globals.NEW_REJECTION_EMAIL_PROPS.REASON_2_MAIL_CONTENT.length) + '/1024'
                    }</div></>}
                  </div>
                )}
              {/** End of new Rejection email implementation */}

                {/**START --- New version of accept mail section with role and pre-loaded mail content */}
                {(isNewAcceptanceMail &&
                  <div id="popup-email newRejection-email-container">
                   
                    <div className="newRejection-email-content-label1">
                      <label className="newRejection-email-content-label">{Globals.NEW_REJECTION_EMAIL_PROPS.EMAIL_CONTENT_LABEL}</label>
                    </div>
                    <div className="newRejection-email-content-container">
                      <label className="new-preloaded-accept-mail-content">{emailContent}{//Globals.NEW_ACCEPTED_EMAIL_PROPS.EMAIL_CONTENT
                      }
                      </label>
                    </div>
                    <div className="newRejection-mail-word-counter">{
                      (rejectionOptionSelected.reason1 ? Globals.NEW_REJECTION_EMAIL_PROPS.REASON_1_MAIL_CONTENT.length :
                        Globals.NEW_ACCEPTED_EMAIL_PROPS.EMAIL_CONTENT.length) + '/1024'
                    }</div>
                  </div>
                )}
                {/** End */}
              {(comments) && (

                <div id="popup-email">
                  <div className="popup-email-title">{textAreaTitle}</div>
                  <div>
                    <textarea
                      value={text}
                      onChange={handleChange}
                        placeholder={Globals.SM_EVAL_COMMENTS_PLACEHOLDER}
                      className={textAreaStyle}
                      maxLength={limit}
                    />
                    <p style={{ textAlign: "right", margin: "5px 0" }}>
                      {text.length}/{limit}
                    </p>
                  </div>
                </div>
              )}
            </div>
            <div
              className="popup-text-edit"
              style={{
                display: props.popupType === "successedit" ? "block" : "none",
              }}
            >
              {props.popupType === "successedit" && (
                <span>{Globals.EDIT_PROFILE.POPUP.Update.MESSAGE}</span>
              )}
            </div>

            <div className="popup-actions">
              {props.popupType !== "failed" &&
                  props.popupType !== "success" &&
                  props.popupType !== "activate-success" &&
                  props.popupType !== "activate-failure" && 
                  props.popupType !=="confidential-agreement" &&
                  !props.remove_cancel_btn && (
                  <button
                    onClick={closePopup}
                    className={`cancel-button-bg cancel-btn-${multiLang}`}
                  >
                    {Globals.HALF_PAGE_BRIEF_DETAILS.CANCEL}
                  </button>
                )}

              {props.negativeAction && (
                <button
                  onClick={handleNegativeAction}
                  className={`negative-button-bg`}
                  disabled={(isEmailPopupVaild||disable)}
                >
                  {props.negativeActionText}
                </button>
              )}
              {props.normalAction && (
                <button
                    disabled={isEmailPopupVaild || disable || (newRejection&& !(rejectionOptionSelected.reason1 || rejectionOptionSelected.reason2))}
                  onClick={handleNormalAction}
                    className={`${
                      props.popupType === "failed"
                      ? "failed-btn"
                      : props.popupType === "success"
                        ? `success-btn success-btn-${multiLang}`
                        : "action-button"
                    }`}
                >
                  <span className="btn-text">{props.normalActionText}</span>
                </button>
              )}
            </div>
          </div>
        </div>
        </div>
      )}
    </>
  );
};

export default PopUp;